// @ts-nocheck
import "../advanced.scss";

import DropDown from "atoms/dropdown/dropdown";
import Icon from "atoms/icons/icon";
import Tag from "atoms/tag/tag";
import _ from "lodash";
import {
  getGridFilters,
  getGridFiltersByColumn,
  getGridMetadata,
} from "models/dynamicGrid/selector";
import { GRID_EVENTS } from "molecules/ReactGrid/agGrid/constants";
import { Events } from "molecules/ReactGrid/agGrid/utils/events";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import React, {
  useEffect,
  useMemo,
  useState,
} from "react";
import { getDispatch, getState } from "reducers";
import { formatDate } from "utils/utilities";
import { v4 as uuidv4 } from "uuid";

import * as query from "../query";
import * as sagaActions from "../sagaActions";
import * as types from "../type";
import agGridSelectColumnDefinitions from "./agGridSelectColumnDefinitions";
import { useSelector } from "react-redux";
import { REQUESTS } from "utils/services/thetaretail/requests";

type TProps = {
  parameters: types.TSearchParameter[];
  searchFilters: types.TSearchQuery[];
  tableId?: number;
  isServerHandled: boolean;
  allowOperator?: boolean;
  operator?: string;
  updateOperator?: (checked: boolean, event: MouseEvent) => void;
};

const defaultProps: Partial<TProps> = {
  parameters: [],
  searchFilters: [],
  isServerHandled: false,
  allowOperator: false,
  operator: "AND",
  updateOperator: (checked: boolean, event: MouseEvent) => {},
};

export const AgGridSearchMultiSelectFilter = ({
  currentQuery,
  currentColumnRef,
  tableId,
  onToggle,
  isEnabled,
  isInline,
  onUpdateQueries = () => null,
  isTagFilter = false,
  ...props
}) => {
  const gridMetaData = useSelector((state) => getGridMetadata(state, tableId));
  const columnData = currentColumnRef?.colDef?.metaData;
  const selectedCriteria = query.getSearchParameters(
    currentColumnRef?.colDef?.metaData ?? {}
  );
  const [isTagFilterOpen, setTagFilterOpen] = useState(false);
  const [filterOption, updateFilterOption] = useState(
    currentQuery?.operator ||
      query.getCriteriaOperators(selectedCriteria ?? {})[0]
  );
  const [currentSearchInput, updateCurrentSearchInput] = useState(
    currentQuery?.query?.from || currentQuery?.query
  );
  const [currentSearchInputEnd, updateCurrentSearchInputEnd] = useState(
    currentQuery?.query?.to
  );
  const isOperatorBtwn =
    filterOption.value === "btw" || filterOption.value === "nbtw";
  const isOperatorEmpty =
    filterOption.value === "empty" || filterOption.value === "not.empty";
  const isOperatorIn =
    filterOption.value === "in" || filterOption.value === "not.in";
  const isOperatorBoolean =
    filterOption.value === "is.false" || filterOption.value === "is.true";
  const isOperatorBulkIn = filterOption.value === "bulk.in";
  const isOperatorDate = selectedCriteria.type === "date";
  const isEqualsOperator =
    filterOption.value === "eq" || filterOption.value === "neq";
  const multiSelectOptionsRequest =
    gridMetaData?.dataProviderOptions?.service === "grid" ||
    gridMetaData?.dataProviderOptions?.service === "adminSettings" ||
    gridMetaData?.dataProviderOptions?.service === "upload" ||
    gridMetaData?.dataProviderOptions?.service === "storeschedule"||gridMetaData?.dataProviderOptions?.service === "storesku"
      ? REQUESTS.POST.GET_MULTI_SELECT_OPTIONS
      : REQUESTS.POST.GET_MULTI_SELECT_OPTIONS_ACL;

  const selectionProviderOptions = useMemo(
    () => ({
      type: "POST",
      version: 2,
      ...multiSelectOptionsRequest,
      pathParams: { tableId },
      tableId,
      service:
        gridMetaData?.dataProviderOptions?.service === "upload" ||
        gridMetaData?.dataProviderOptions?.service === "storeschedule"||gridMetaData?.dataProviderOptions?.service === "storesku"
          ? "grid"
          : gridMetaData?.dataProviderOptions?.service,
      body: {},
    }),
    [tableId]
  );

  useEffect(() => {
    updateCurrentSearchInput(currentQuery?.query?.from || currentQuery?.query);
    updateCurrentSearchInputEnd(currentQuery?.query?.to);
    updateFilterOption(
      currentQuery?.operator ||
        query.getCriteriaOperators(selectedCriteria ?? {})[0]
    );
  }, [currentQuery.query, currentQuery?.operator]);

  const dropdownOptions = query.getCriteriaOperators(selectedCriteria);
  const isInputVisible = !_.some(
    ["empty", "not.empty", "is.true", "is.false"],
    (c) => c === filterOption.value
  );

  const dispatch = getDispatch();

  const onUpdateInput = (e, type) => {
    if (type === "date") {
      const filterDate = formatDate(e);
      updateCurrentSearchInput(filterDate);
      return;
    }
    updateCurrentSearchInput(e.target.value);
  };

  const removeQuery = () => {
    let queries = getGridFiltersByColumn(
      getState(),
      tableId,
      currentQuery?.criteria?.rowIdentifier
    );
    let updated = _.filter(queries, (q) => q.id !== currentQuery.id);
    Events.publish(GRID_EVENTS.CLEAR_SELECTION, {
      tableId,
    });
     dispatch(
      sagaActions.removeQuery({
        tableId,
        query: currentQuery,
      })
    );
    if (onUpdateQueries) {
      onUpdateQueries(updated);
    }
  };
  const updateQuery = (params) => {
    let updated = [];
    const searchQueriesAll = getGridFilters(getState(), tableId);
    Events.publish(GRID_EVENTS.CLEAR_SELECTION, {
      tableId,
    });
    const {
      id,
      selectedCriteria,
      searchInput,
      searchInputEnd,
      selectedOperator,
      isUpdate,
    } = params;

    if (
      searchQueriesAll?.search.find(
        (q) => q?.criteria?.rowIdentifier === selectedCriteria?.rowIdentifier
      )
    ) {
      updated = _.map(searchQueriesAll?.search, (q) => {
        if (q.criteria?.rowIdentifier === selectedCriteria?.rowIdentifier) {
          return {
            id: q.id || uuidv4(),
            criteria: selectedCriteria,
            query:
              selectedOperator &&
              (selectedOperator.value === "btw" ||
                selectedOperator.value === "nbtw")
                ? { from: searchInput, to: searchInputEnd }
                : searchInput,
            operator: selectedOperator,
          };
        }
        return q;
      });
    } else {
      updated = [
        ...searchQueriesAll?.search,
        {
          id: id || uuidv4(),
          criteria: selectedCriteria,
          query:
            selectedOperator &&
            (selectedOperator.value === "btw" ||
              selectedOperator.value === "nbtw")
              ? { from: searchInput, to: searchInputEnd }
              : searchInput,
          operator: selectedOperator,
        },
      ];
    }

    if (onUpdateQueries) {
      onUpdateQueries(_.filter(updated, (val) => val.id));
    }
    setTagFilterOpen(false);
    dispatch(
      sagaActions.updateAgQueries({
        searchQueries: updated,
        tableId,
      })
    );
    // currentColumnRef.setFilterActive();
  };
  const handleSubmit = (e, isClick, options) => {
    let searchInput = (
      options?.currentSearchInput || currentSearchInput
    )?.trim();
    const searchInputEnd = (
      options?.currentSearchInputEnd || currentSearchInputEnd
    )?.trim();
    
    // Format bulk.in values: split by comma (handling spaces), trim, and wrap in single quotes
    const selectedOperator = options?.filterOption || filterOption;
    if (selectedOperator?.value === "bulk.in" && searchInput) {
      // Split by comma first, then process each part
      const parts = searchInput.split(',');
      const formattedValues = [];
      
      for (let part of parts) {
        part = part.trim();
        if (!part) continue;
        
        // Check if this part is already quoted
        const quotedMatch = part.match(/^'([^']*)'$/);
        if (quotedMatch) {
          // Already properly quoted, extract the value
          formattedValues.push(quotedMatch[1]);
        } else {
          // Not quoted or partially quoted, extract any unquoted value
          // Remove any existing quotes and trim
          const unquotedValue = part.replace(/^'|'$/g, '').trim();
          if (unquotedValue) {
            formattedValues.push(unquotedValue);
          }
        }
      }
      
      // Format all values with single quotes and join
      searchInput = formattedValues
        .filter((v, index, self) => self.indexOf(v) === index) // Remove duplicates
        .map((v) => `'${v}'`)
        .join(',');
    }
    
    if (
      (!searchInput || (isOperatorBtwn && !searchInputEnd?.trim())) &&
      isInputVisible
    ) {
      return;
    }
    if (e?.keyCode === 13 || isClick) {
      updateQuery({
        selectedCriteria,
        searchInput,
        searchInputEnd,
        selectedOperator,
        tableId,
        id: currentQuery?.id,
        isUpdate: currentQuery?.id,
      });
    }
  };

  const onUpdateModel = ({ dateEvent, filter, isRange }) => {
    if (filter) {
      updateFilterOption(filter);
      if (
        (filter.value === "btw" || filter.value === "nbtw") &&
        (!currentSearchInput || !currentSearchInputEnd)
      ) {
        return;
      }
      if (isEqualsOperator || isOperatorIn) {
        return;
      }
      return;
    }
    if (dateEvent) {
      const dateValue = dateEvent.target.value;
      if (_.isArray(dateValue)) {
        const startDate = formatDate(dateValue[0]);
        const endDate = formatDate(dateValue[1]);
        updateCurrentSearchInput(formatDate(startDate));
        updateCurrentSearchInputEnd(formatDate(endDate));
      } else {
        const updateDate = formatDate(dateValue);
        updateCurrentSearchInput(updateDate);
      }
    }
  };

  const componentData = useMemo(() => {
    // if (gridMetaData?.MultiSelectOptions) {
    return agGridSelectColumnDefinitions.MULTISELECT_CONFIG.getTemplate({
      isOperatorBtwn,
      isOperatorBoolean,
      currentSearchInput,
      isOperatorIn,
      currentSearchInputEnd,
      isOperatorBulkIn,
      selectionProviderOptions,
      isOperatorEmpty,
      updateCurrentSearchInput,
      updateCurrentSearchInputEnd,
      isOperatorDate,
      isEqualsOperator,
      selectedCriteria,
      onUpdateModel,
      onUpdateInput,
      handleSubmit,
      isInline,
      columnData,
      ...props,
    });
    // } else {
    // 	return agGridSelectColumnDefinitions.DEFAULT_CONFIG.getTemplate({
    // 		isOperatorBtwn,
    // 		currentSearchInput,
    // 		isOperatorIn,
    // 		isOperatorBulkIn,
    // 		selectedCriteria,
    // 		currentSearchInputEnd,
    // 		updateCurrentSearchInput,
    // 		updateCurrentSearchInputEnd,
    // 		selectionProviderOptions,
    // 		isOperatorEmpty,
    // 		onUpdateModel,
    // 		isOperatorDate,
    // 		isEqualsOperator,
    // 		onUpdateInput,
    // 		handleSubmit,
    // 		isInline,
    // 		columnData
    // 	})
    // }
  }, [
    isOperatorBtwn,
    currentSearchInput,
    isOperatorIn,
    currentSearchInputEnd,
    isOperatorBtwn,
    isOperatorDate,
    isEqualsOperator,
    gridMetaData,
    filterOption,
    isOperatorEmpty,
    isOperatorBulkIn,
    isOperatorBoolean
  ]);

  if (!currentColumnRef) {
    return;
  }
  const isTagEnabled = isTagFilter && !isTagFilterOpen;

  if (isTagEnabled && currentQuery) {
    const query = currentQuery.query;

    const value = (() => {
      if (_.isObject(query)) {
        // Handle range object
        return `${query.from} And ${query.to}`;
      }

      if (typeof query === "string") {
        // Normalize to: Costco, Lowes
        return query
          .match(/'[^']*'|[^,]+/g) // Match quoted OR plain segments
          ?.map((v) => v.replace(/^'|'$/g, "").trim()) // Remove surrounding quotes and trim
          .filter(Boolean)
          .join(", ");
      }

      return "";
    })();

    return (
      <Tag tooltipText={`${currentQuery?.criteria?.displayName || ""} ${
            currentQuery?.operator?.displayName || ""
          } ${value}`}
        onClick={() => setTagFilterOpen(true)}
        closable
        onClose={removeQuery}
      >
        {_.truncate(
          `${currentQuery?.criteria?.displayName || ""} ${
            currentQuery?.operator?.displayName || ""
          } ${value}`,
          { length: 30 }
        )}
      </Tag>
    );
  }

  return (
    <Stack gutter="small">
      <StackItem isStretch isGrow>
        <Stack isVertical={!isTagFilter} gutter="small">
          {isTagFilter && (
            <StackItem position="center">
              {currentQuery?.criteria?.displayName}
            </StackItem>
          )}
          <StackItem isStretch isGrow>
            <DropDown
              className="multiselectFilter"
              key={"options"}
              selectedOption={filterOption}
              options={dropdownOptions}
              updateHandler={(e) => {
                onUpdateModel({ filter: e });
              }}
            />
          </StackItem>
          {componentData}
        </Stack>
      </StackItem>
      <StackItem>
        <Stack
          isVertical={!isTagFilter}
          gutter={isTagFilter ? "medium" : "small"}
          align={!isTagFilter && "space-between"}
        >
          {!isOperatorBulkIn &&
            !isOperatorIn &&
            !(isEqualsOperator && columnData.ColumnType === "Date") && (
              <StackItem align="center" position="center" isGrow>
                <Icon
                  isActive
                  size={"small"}
                  faAlias={"faSave"}
                  onClick={(e) => handleSubmit(e, true)}
                />
              </StackItem>
            )}
          {currentQuery?.id && (
            <StackItem align="end" position="center" isGrow>
              <Icon
                isActive
                size={"small"}
                faAlias={"faTrash"}
                onClick={() => removeQuery(currentQuery)}
              />
            </StackItem>
          )}
        </Stack>
      </StackItem>
    </Stack>
  );
};
